(() => {
  const storageKey = "myequiart_partner";
  const attributionDays = 30;

  function getPartnerFromUrl() {
    const params = new URLSearchParams(
      window.location.search
    );

    return params.get("partner");
  }

  function savePartner(handle) {
    if (!handle) {
      return null;
    }

    const partner = {
      handle,
      capturedAt: new Date().toISOString(),
      expiresAt:
        Date.now() +
        attributionDays * 24 * 60 * 60 * 1000
    };

    localStorage.setItem(
      storageKey,
      JSON.stringify(partner)
    );

    return partner;
  }

  function getSavedPartner() {
    const storedValue = localStorage.getItem(storageKey);

    if (!storedValue) {
      return null;
    }

    try {
      const partner = JSON.parse(storedValue);

      if (
        !partner.expiresAt ||
        Date.now() > partner.expiresAt
      ) {
        localStorage.removeItem(storageKey);
        return null;
      }

      return partner;
    } catch (error) {
      localStorage.removeItem(storageKey);
      return null;
    }
  }

  async function updateCart(partner) {
    if (!partner) {
      return;
    }

    const root =
      window.Shopify?.routes?.root || "/";

    try {
      const response = await fetch(
        `${root}cart/update.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            attributes: {
              "Partner ID": partner.handle,
              "Partner source": "Partner store",
              "Partner captured": partner.capturedAt
            }
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          `Cart update failed: ${response.status}`
        );
      }
    } catch (error) {
      console.error(
        "Partner tracking failed",
        error
      );
    }
  }

  async function initializePartnerTracking() {
    const urlPartner = getPartnerFromUrl();

    const partner = urlPartner
      ? savePartner(urlPartner)
      : getSavedPartner();

    await updateCart(partner);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializePartnerTracking
    );
  } else {
    initializePartnerTracking();
  }
})();